const CONFIGURATION = {
    defaultTheme: 'mipasa-light',
    authorizedDomains: ['mipasa.com'],
    apps: {
        mipasa: {
            enabled: true,
            url: 'https://sage.mipasa.com',
        },
        unbounded: {
            enabled: false,
        },
        papillon: {
            enabled: false,
        },
        crypto: {
            enabled: false,
        },
        dpasa: {
            enabled: false,
        },
        soikie: {
            enabled: false,
        },
    },
    oidc: {
        github: true,
        google: true,
        ethereum: false,
    },
    sentry: {
        enabled: true,
        dsn: 'https://a7607287ba53453897b34276cb967443@o952724.ingest.sentry.io/6753216',
        tunnel: '/tunnel',
        environment: 'Sage',
    },
};
export default CONFIGURATION;
